/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Custom_Properties_Create_KeyInputs */

const en_forms_custom_properties_create_key = /** @type {(inputs: Forms_Custom_Properties_Create_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Key`)
};

const de_forms_custom_properties_create_key = /** @type {(inputs: Forms_Custom_Properties_Create_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schlüssel`)
};

/**
* | output |
* | --- |
* | "Key" |
*
* @param {Forms_Custom_Properties_Create_KeyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_custom_properties_create_key = /** @type {((inputs?: Forms_Custom_Properties_Create_KeyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Custom_Properties_Create_KeyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_custom_properties_create_key(inputs)
	return de_forms_custom_properties_create_key(inputs)
});